export default [
    {
        path: '/pages/property/communitySettingManage',
        meta: { title: '小区配置' },
        name: '/pages/property/communitySettingManage',
        component: () => import('@/views/system/communitySettingManageList.vue')
    },
    {
        path: '/pages/property/workflowManage',
        meta: { title: '流程管理' },
        name: '/pages/property/workflowManage',
        component: () => import('@/views/system/workflowManageList.vue')
    },
    {
        path: '/pages/property/workflowSettingManage',
        meta: { title: '流程设置' },
        name: '/pages/property/workflowSettingManage',
        component: () => import('@/views/system/workflowSettingManageList.vue')
    },
    {
        path: '/pages/property/attendanceLeaveAuditList',
        meta: { title: '请假审批' },
        name: '/pages/property/attendanceLeaveAuditList',
        component: () => import('@/views/attendance/attendanceLeaveAuditList.vue')
    },
    {
        path: '/pages/property/attendanceOvertimeAuditList',
        meta: { title: '加班审批' },
        name: '/pages/property/attendanceOvertimeAuditList',
        component: () => import('@/views/attendance/attendanceOvertimeAuditList.vue')
    },
    {
        path: '/pages/property/attendanceLeaveHisList',
        meta: { title: '请假记录' },
        name: '/pages/property/attendanceLeaveHisList',
        component: () => import('@/views/attendance/attendanceLeaveHisList.vue')
    },
    {
        path: '/pages/property/attendanceOvertimeHisList',
        meta: { title: '加班记录' },
        name: '/pages/property/attendanceOvertimeHisList',
        component: () => import('@/views/attendance/attendanceOvertimeHisList.vue')
    },
    {
        path: '/pages/common/storeInfoManage',
        meta: { title: '商户信息' },
        name: '/pages/common/storeInfoManage',
        component: () => import('@/views/system/storeInfoManageList.vue')
    },
    {
        path: '/pages/property/publicWeChatManage',
        meta: { title: '公众号' },
        name: '/pages/property/publicWeChatManage',
        component: () => import('@/views/system/publicWeChatManageList.vue')
    },
    {
        path: '/pages/property/smallWeChatManage',
        meta: { title: '小程序配置' },
        name: '/pages/property/smallWeChatManage',
        component: () => import('@/views/system/smallWeChatManageList.vue')
    },
    {
        path: '/pages/fee/paymentPool',
        meta: { title: '支付配置' },
        name: '/pages/fee/paymentPool',
        component: () => import('@/views/system/paymentPoolList.vue')
    },
    {
        path: '/pages/log/operateDataLog',
        meta: { title: '操作日志' },
        name: '/pages/log/operateDataLog',
        component: () => import('@/views/system/operateDataLogList.vue')
    },
    {
        path: '/pages/property/historyFeeDetailImport',
        meta: { title: '历史缴费导入' },
        name: '/pages/property/historyFeeDetailImport',
        component: () => import('@/views/system/historyFeeDetailImportList.vue')
    },
    {
        path: '/pages/property/feePrintSpecManage',
        meta: { title: '打印配置' },
        name: '/pages/property/feePrintSpecManage',
        component: () => import('@/views/system/feePrintSpecManageList.vue')
    },
    {
        path: '/pages/property/feePrintPageManage',
        meta: { title: '收据模板' },
        name: '/pages/property/feePrintPageManage',
        component: () => import('@/views/system/feePrintPageManageList.vue')
    },
    {
        path: '/pages/property/downloadTempFile',
        meta: { title: '下载中心' },
        name: '/pages/property/downloadTempFile',
        component: () => import('@/views/system/downloadTempFileList.vue')
    },
    {
        path: '/pages/property/assetImportLog',
        meta: { title: '导入日志' },
        name: '/pages/property/assetImportLog',
        component: () => import('@/views/system/assetImportLogList.vue')
    },
    {
        path: '/views/system/assetImportLogDetail',
        name: '/views/system/assetImportLogDetail',
        component: () => import('@/views/system/assetImportLogDetailList.vue')
    },
    {
        path: '/pages/fee/payFeeQrcode',
        meta: { title: '支付二维码' },
        name: '/pages/fee/payFeeQrcode',
        component: () => import('@/views/fee/payFeeQrcodeList.vue')
    },
    {
        path: '/views/system/menuUserManage',
        name: '/views/system/menuUserManage',
        component: () => import('@/views/system/menuUserManageList.vue')
    },
]